import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";
import CategoriesAccordion from "./CategoriesAccordion";

const ShopCategories = ({
  categories,
  getSortParams,
  categoriesItems,
  categoriesFilter,
  setCategoriesFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className="sidebar-widget">
      <h4 className="pro-sidebar-title">{t("filter_by_category")} </h4>
      <div className="sidebar-widget-list mt-30">
        {categoriesItems ? (
          <ul>
            {categoriesItems?.map(
              (category, key) =>
                !category?.parent_id && (
                  <CategoriesAccordion
                    categoriesFilter={categoriesFilter}
                    setCategoriesFilter={setCategoriesFilter}
                    category={category}
                  />
                )
            )}
          </ul>
        ) : (
          t("no_category")
        )}
      </div>
    </div>
  );
};

ShopCategories.propTypes = {
  categories: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopCategories;
